import React from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { shape as pesticideShape } from '~/src/IPM/Pesticide/validation'
import SprayIcon from '~/src/UI/Icons/Spray'

import BaseWidget from './Base'

export const WidgetPesticide = props => {
  const { pesticide, Icon, ...passthru } = props

  if (!pesticide || !pesticide.name) return null

  return (
    <BaseWidget
      label="pesticide"
      {...passthru}
      title={pesticide.name}
      description={pesticide.activeIngredient}
      Icon={Icon}
    />
  )
}
WidgetPesticide.propTypes = {
  pesticide: pesticideShape.isRequired,
  Icon: PropTypes.elementType,
}
WidgetPesticide.defaultProps = {
  Icon: SprayIcon,
}
WidgetPesticide.displayName = 'Widget/Pesticide'

export default React.memo(props => {
  const { id, ...passthru } = props
  const { pesticides } = useConnect('selectPesticides')
  const { [id]: pesticide } = pesticides

  return <WidgetPesticide {...passthru} pesticide={pesticide} />
})
